// Office Action Task Definitions

export interface OATask {
  id: string;
  name: string;
  description: string;
  task_type: string;
  has_mpep: boolean;
  mpep_sections?: string[];
  category: string;
}

export const OA_TASK_TYPES = {
  OA_EXTRACT: 'oa_extract',
  OA_ANALYZE: 'oa_analyze',
  OA_SUMMARY_ART: 'oa_summary_art',
  OA_TIMELINE: 'oa_timeline',
  OA_REPORTING_EMAIL: 'oa_reporting_email',
} as const;

export const OA_TASKS: OATask[] = [
  {
    id: OA_TASK_TYPES.OA_EXTRACT,
    name: 'Extract Office Action Info',
    description: 'Extract key information and requirements from office action documents.',
    task_type: OA_TASK_TYPES.OA_EXTRACT,
    has_mpep: true,
    mpep_sections: ['706', '706.07'],
    category: 'office_action',
  },
  {
    id: OA_TASK_TYPES.OA_ANALYZE,
    name: 'Analyze Office Action Issues',
    description: 'Analyze office action issues and provide detailed assessment of claims and rejections.',
    task_type: OA_TASK_TYPES.OA_ANALYZE,
    has_mpep: true,
    mpep_sections: ['706'],
    category: 'office_action',
  },
  {
    id: OA_TASK_TYPES.OA_SUMMARY_ART,
    name: 'Summarize Office Action Prior Art',
    description: 'Summarize prior art references cited in office actions with detailed analysis.',
    task_type: OA_TASK_TYPES.OA_SUMMARY_ART,
    has_mpep: true,
    mpep_sections: ['706'],
    category: 'office_action',
  },
  {
    id: OA_TASK_TYPES.OA_TIMELINE,
    name: 'Build Office Action Timeline',
    description: 'Create timeline of prosecution history from office action documents.',
    task_type: OA_TASK_TYPES.OA_TIMELINE,
    has_mpep: false,
    category: 'office_action',
  },
  {
    id: OA_TASK_TYPES.OA_REPORTING_EMAIL,
    name: 'Generate OA Reporting Email',
    description: 'Generate a professional email report summarizing the office action for client communication.',
    task_type: OA_TASK_TYPES.OA_REPORTING_EMAIL,
    has_mpep: false,
    category: 'office_action',
  },
];
